module.exports = {"id":"209818","name":"Joshua Brenet","rating":"74","photo":"./data/images/photos/1/209818.png","club":{"name":"PSV","logo":"./data/images/clubs/PSV.png"},"positions":["DG","DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoshuaBrenet0.json
// module id = 2190
// module chunks = 0